module.exports = __webpack_public_path__ + "static/64import-10996c4281978b8513512d6f398ab675.png";